/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { CardWrapper, ContentContainer } from "../../../styles/component/style";
import { PrimaryCTAButton } from "../../common/Buttons";
import { Formik } from "formik";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";
import useLoader from "../../../hooks/useLoader";
import AuthService from "../../../services/AuthService";
import { CustomInputField } from "../../common/FormInputs";
import {
  Grid,
  FormControlLabel,
  RadioGroup,
  Radio,
  makeStyles,
  Modal,
} from "@material-ui/core";
import {
  DrawerContainer,
  HeadingContainer,
  Heading,
  CloseModal,
} from "../../pages/CaseDetails/common/RTMP";
import { ButtonContainer } from "../FinalApprover/Styles";

const useStyles = makeStyles((themes) => ({
  formLabel: {
    fontFamily: "openSans-SemiBold, sans-serif",
    color: "#293461",
  },
  root: {
    margin: 15,
    [themes.breakpoints.up(640)]: {
      margin: "0px 46px",
    },
    "& .MuiTab-root": {
      padding: "5px 0",
      [themes.breakpoints.up(640)]: {
        padding: "6px 12px",
      },
    },
    "& .MuiTab-wrapper": {
      fontSize: 12,
      [themes.breakpoints.up(640)]: {
        fontSize: 16,
      },
    },
  },

  radioRoot: {
    margin: 15,
    [themes.breakpoints.up(640)]: {
      margin: "0px 26px",
    },
    "& .MuiTab-root": {
      padding: "5px 0",
      [themes.breakpoints.up(640)]: {
        padding: "6px 12px",
      },
    },
    "& .MuiTab-wrapper": {
      fontSize: 12,
      [themes.breakpoints.up(640)]: {
        fontSize: 16,
      },
    },
  },
}));

const GenerateGlobalMeeting = ({
  publicModal,
  setPublicModal,
  id,
  resolutionKind,
  title,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { setLoader } = useLoader();
  const [link, setLink] = useState("");
  const classes = useStyles();

  async function onFormSubmit(values, { resetForm }) {
    try {
      setLoader({ state: true, message: "Please wait..." });
      const payload = {
        caseId: values?.caseId,
        caseType: values?.caseType,
        publicViewer: true,
        title: values?.title,
      };
      if (values.typeOfAction) {
        const response = await AuthService.createPublicLink(payload);
        setLink(response?.publicUrl);
      } else {
        const response = await AuthService.removeToken({
          meetingId: values?.caseId,
        });
        resetForm();
        setLink("");
        enqueueSnackbar(response.message, {
          variant: "success",
        });
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  return (
    <Modal open={publicModal} onClose={() => setPublicModal(false)}>
      <DrawerContainer width="40%">
        <HeadingContainer>
          <Heading>Public Meeting</Heading>
          <CloseModal
            onClick={() => setPublicModal(false)}
            src={require("../../../assets/images/closeModal.svg")}
          />
        </HeadingContainer>
        <>
          <Formik
            initialValues={{
              caseId: id,
              caseType: resolutionKind || "hearing",
              id: 266 || "",
              meetingId: id,
              typeOfAction: 1,
              title: title,
            }}
            enableReinitialize
            onSubmit={onFormSubmit}
            validateOnBlur
            validateOnChange
          >
            {({
              values,
              handleChange,
              errors,
              handleSubmit,
              touched,
              handleBlur,
              setFieldValue,
              resetForm,
            }) => (
              <CardWrapper
                onSubmit={handleSubmit}
                style={{
                  // width: "50%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Grid
                  className={classes.radioRoot}
                  item
                  xs={12}
                  spacing={2}
                  style={{ marginTop: "5px", padding: 16 }}
                >
                  <RadioGroup
                    style={{
                      flexDirection: "row",
                      marginLeft: "10px",
                    }}
                    name={"typeOfAction"}
                    value={values.typeOfAction}
                    onChange={(e) => {
                      setFieldValue("typeOfAction", parseInt(e.target.value));
                    }}
                  >
                    {[
                      {
                        label: "Generate Meeting Link",
                        value: 1,
                      },
                      { label: "Remove Meeting Id", value: 0 },
                    ].map((radio, key) => (
                      <FormControlLabel
                        {...{ key }}
                        classes={{ label: classes.formLabel }}
                        value={radio.value}
                        control={
                          <Radio size="medium" style={{ color: "#00838c" }} />
                        }
                        label={radio.label}
                      />
                    ))}
                  </RadioGroup>
                </Grid>
                {values.typeOfAction ? (
                  <>
                    {/* <ContentContainer>
                      {[{ name: "id", type: "number", label: "Viewer Id" }].map(
                        (input, index) => {
                          return (
                            <FormField
                              key={index}
                              {...{
                                touched,
                                errors,
                                input,
                                values,
                                handleChange,
                                handleBlur,
                                setFieldValue,
                              }}
                            />
                          );
                        },
                      )}
                    </ContentContainer> */}
                    {link?.length ? (
                      <div style={{ display: "flex" }}>
                        <CustomInputField variant="outlined" value={link} />
                        <PrimaryCTAButton
                          style={{
                            borderRadius: 60,
                            width: "auto",
                            marginLeft: 10,
                          }}
                          onClick={() => {
                            navigator.clipboard.writeText(link);
                            enqueueSnackbar("Link copied successfully", {
                              variant: "success",
                            });
                          }}
                        >
                          Copy
                        </PrimaryCTAButton>
                      </div>
                    ) : null}
                  </>
                ) : (
                  <ContentContainer className="disabledArrows">
                    {/* {[
                      {
                        name: "meetingId",
                        type: "number",
                        label: "Meeting Id",
                      },
                    ].map((input, index) => {
                      return (
                        <FormField
                          key={index}
                          {...{
                            touched,
                            errors,
                            input,
                            values,
                            handleChange,
                            handleBlur,
                            setFieldValue,
                          }}
                        />
                      );
                    })} */}
                  </ContentContainer>
                )}
                <ButtonContainer>
                  <PrimaryCTAButton
                    style={{
                      marginLeft: "25px",
                      marginRight: "25px",
                      marginBottom: "25px",
                      marginTop: "25px",
                    }}
                    type="submit"
                    onClick={handleSubmit}
                  >
                    Proceed
                  </PrimaryCTAButton>
                </ButtonContainer>
              </CardWrapper>
            )}
          </Formik>
        </>
      </DrawerContainer>
    </Modal>
  );
};

export default GenerateGlobalMeeting;
